var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPromoAndNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0928 2.65535C18.9551 2.66759 18.8179 2.69591 18.6846 2.74129L10 5.70223V16.2979L18.6855 19.2589C19.2185 19.4404 19.8101 19.353 20.2686 19.0255C20.7261 18.698 21 18.1661 21 17.6026V13.1016C21.7323 12.8046 22.25 12.0889 22.25 11.2501C22.25 10.4113 21.7323 9.69554 21 9.39851V4.39754C21 3.83404 20.7266 3.30219 20.2686 2.97469C19.9247 2.72869 19.5057 2.61862 19.0928 2.65535ZM8.5 6.05574L4.53906 6.36043C3.11456 6.46993 2 7.67364 2 9.10164V12.8985C2 14.2885 3.05726 15.4665 4.42676 15.629L4.90039 19.8936C5.00189 20.8091 5.77381 21.5001 6.69531 21.5001C7.69081 21.5001 8.5 20.6899 8.5 19.6944V6.05574Z",
    fill: "#5E7360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPromoAndNotification);
export default __webpack_public_path__ + "static/media/ic_promo_and_notification.64247ca8925398630a802b037e5142ac.svg";
export { ForwardRef as ReactComponent };